import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';
import { School } from 'src/app/model/school.model';

@Injectable({
    providedIn: 'root'
})
export class ProvisionalSchoolsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    show(id: number): Observable<any> {
        return this.get<any>(EndPoints.provisionalSchools_Show, '', id);
    }

    showByNodeId(nodeId: number): Observable<any> {
        return this.post<any>(EndPoints.provisionalSchools_ShowByNodeId, false, null, {
            nodeId: nodeId
        });
    }

    update(editProvisionalSchool: any): Observable<any> {
        return this.post<any>(EndPoints.provisionalSchools_Update, false, null, {
            editProvisionalSchool: editProvisionalSchool
        });
    }

    updateCoeAnswers(provisionalSchool: any): Observable<any> {
        return this.post<any>(EndPoints.provisionalSchools_UpdateCoeAnswers, false, null, {
            provisionalSchool: provisionalSchool
        });
    }

    resolveProvisionalSchool(provisionalSchool: any, newSchool: School): Observable<any> {
        return this.post<any>(EndPoints.provisionalSchools_ResolveProvisionalSchool, false, null, {
            provisionalSchool: provisionalSchool,
            newSchool: newSchool
        });
    }
}
